import styled from 'styled-components';
import { XIColors } from '@inmoment/the-kitchen';
const { grey } = XIColors;
export const PropChangersWrapper = styled.div`
  box-sizing: border-box;
  border-left: 1px solid ${grey.light[70]};
  border-right: 1px solid ${grey.light[70]};
  height: 100%;
  width: 282px;
  background: white;
  padding: 24px;
  position: absolute;
  right: 0;
  overflow: auto;
`;
